import StatusBadge from 'common/StatusBadge';
import moment from 'moment';

export function getAppointmentDisplayStatus(rawStatus, dateStr, timeStr) {
    const s = (rawStatus || '').toLowerCase();

    // Cancelled supersedes everything
    if (s.includes('cancelled')) return 'Cancelled';
    if (s === 'booked') return 'booked';

    // Determine if past (based on date/time)
    if (dateStr) {
        // Try a forgiving date parse first (Month/Day views use this successfully)
        const dateOnly = moment(dateStr);
        if (dateOnly.isValid()) {
            if (!timeStr) {
                if (dateOnly.isBefore(moment(), 'day')) return 'Past';
            } else {
                const base = dateOnly.format('YYYY-MM-DD');
                const dt = moment(`${base} ${timeStr}`, [
                    'YYYY-MM-DD HH:mm:ss',
                    'YYYY-MM-DD HH:mm',
                    'YYYY-MM-DD h:mm A',
                    'YYYY-MM-DD hh:mm A',
                    moment.ISO_8601,
                ]);
                if (dt.isValid() && dt.isBefore(moment())) return 'Past';
            }
        } else {
            // Fallbacks (native, then strict moment)
            const nativeStr = `${dateStr}T${timeStr || '00:00:00'}`;
            const nativeDate = new Date(nativeStr);
            if (!isNaN(nativeDate.getTime())) {
                if (nativeDate.getTime() < Date.now()) return 'Past';
            } else {
                const m = timeStr
                    ? moment(`${dateStr} ${timeStr}`, [
                        'YYYY-MM-DD HH:mm:ss',
                        'YYYY-MM-DD HH:mm',
                        'YYYY-MM-DDTHH:mm:ss',
                        moment.ISO_8601,
                    ], true)
                    : moment(dateStr, ['YYYY-MM-DD', moment.ISO_8601], true).startOf('day');
                const dt = m.isValid() ? m : moment(`${dateStr}T${timeStr || '00:00:00'}`);
                if (dt.isValid() && dt.isBefore(moment())) return 'Past';
            }
        }
    }

    // Pending renders with in-review visuals elsewhere
    if (s === 'pending') return 'in review';
    return s || 'pending';
}

const AppointmentBadge = ({appointmentStatus}) => {
    const getAppointmentBadgeVariant = (appointmentStatus) => {
        const status = appointmentStatus?.toLowerCase();
        if (status === 'booked') {
            return 'active';
        } else if (status === 'pending') {
            // Use the blue "In Review" badge styling for pending appointments
            return 'in review';
        } else if (status === 'active') {
            return 'pending';
        } else if (status?.includes('cancelled')) {
            return 'cancelled';
        } else {
            return '-';
        }
    };
    return (
        <StatusBadge
            status={getAppointmentBadgeVariant(appointmentStatus)}
            badgeName={appointmentStatus?.includes('cancelled') ? 'Cancelled' : appointmentStatus}
        />
    );
};
export default AppointmentBadge;
